import { PropsWithChildren } from 'react';

import { Spin } from 'antd';

export default function Spinner(props: PropsWithChildren) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      data-testid="spinner"
      {...props}
    >
      <Spin />
    </div>
  );
}
